import React, { useState, useContext } from "react";
import { Menu, MenuItem, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import NestedMenuItem from "material-ui-nested-menu-item";
import Context from "../../Context";

export const NestedMenuMUI = () => {
  const { menuValue , setMenuValue, showIcons } = useContext(Context);

  
  const [menuPosition, setMenuPosition] = useState(null);

  
  const handleRightClick = (event) => {
    if (menuPosition) {
      return;
    }
    event.preventDefault();
    setMenuPosition({
      top: event.clientY,
      left: event.clientX,
    });
    /*  console.log("event.pageY", event.clientY);
    console.log("event.pageX", event.clientX);
    console.log("event", event); */
  };

  const handleItemClick = (event) => {
    setMenuPosition(null);
  };

  const handleItemValue0 = () => {
    setMenuPosition(null);

    if ( menuValue) {
      setMenuValue( [...menuValue ,"Cráneo Temporal IZQ Apertura"]) 

      localStorage.setItem('localMenuValue', JSON.stringify(
        [...menuValue ,"Cráneo Temporal IZQ Apertura"]));
      
    } else {
      setMenuValue( ["Cráneo Temporal IZQ Apertura"]);
      localStorage.setItem('localMenuValue', JSON.stringify(
        ["Cráneo Temporal IZQ Apertura"]));
    }
    
  };

  const handleItemValue1 = () => {
    setMenuPosition(null);
    

      if ( menuValue) {
        setMenuValue( [...menuValue ,"Cráneo Temporal IZQ Cierre"]) 
  
        localStorage.setItem('localMenuValue', JSON.stringify(
          [...menuValue ,"Cráneo Temporal IZQ Cierre"]));
        
      } else {
        setMenuValue( ["Cráneo Temporal IZQ Cierre"]);
        localStorage.setItem('localMenuValue', JSON.stringify(
          ["Cráneo Temporal IZQ Cierre"]));
      }
      

  };



  const handleItemValue2 = () => {
    setMenuPosition(null);

    if ( menuValue) {
      setMenuValue( [...menuValue ,"Cráneo Temporal DER Apertura"]) 

      localStorage.setItem('localMenuValue', JSON.stringify(
        [...menuValue ,"Cráneo Temporal DER Apertura"]));
      
    } else {
      setMenuValue( ["Cráneo Temporal DER Apertura"]);
      localStorage.setItem('localMenuValue', JSON.stringify(
        ["Cráneo Temporal DER Apertura"]));
    }


  };
  const handleItemValue3 = () => {
    setMenuPosition(null);

    if ( menuValue) {
      setMenuValue( [...menuValue ,"Cráneo Temporal DER Cierre"]) 

      localStorage.setItem('localMenuValue', JSON.stringify(
        [...menuValue ,"Cráneo Temporal DER Cierre"]));
      
    } else {
      setMenuValue( ["Cráneo Temporal DER Cierre"]);
      localStorage.setItem('localMenuValue', JSON.stringify(
        ["Cráneo Temporal DER Cierre"]));
    }


  };


  const handleItemValue4 = () => {

    setMenuPosition(null);

    if ( menuValue) {
      setMenuValue( [...menuValue ,"Cráneo Occipital Extensión"]) 

      localStorage.setItem('localMenuValue', JSON.stringify(
        [...menuValue ,"Cráneo Occipital Extensión"]));
      
    } else {
      setMenuValue( ["Cráneo Occipital Extensión"]);
      localStorage.setItem('localMenuValue', JSON.stringify(
        ["Cráneo Occipital Extensión"]));
    }


  };



  const handleItemValue5 = () => {
    setMenuPosition(null);

    if ( menuValue) {
      setMenuValue( [...menuValue ,"Cráneo Occipital Flexión"]) 

      localStorage.setItem('localMenuValue', JSON.stringify(
        [...menuValue ,"Cráneo Occipital Flexión"]));
      
    } else {
      setMenuValue( ["Cráneo Occipital Flexión"]);
      localStorage.setItem('localMenuValue', JSON.stringify(
        ["Cráneo Occipital Flexión"]));
    }


  };

  /* Tórax */
  const handleItemValue6 = () => {
    setMenuPosition(null);

    if ( menuValue) {
      setMenuValue( [...menuValue ,"Tórax Acromio-Clavicular IZQ Apertura"]) 

      localStorage.setItem('localMenuValue', JSON.stringify(
        [...menuValue ,"Tórax Acromio-Clavicular IZQ Apertura"]));
      
    } else {
      setMenuValue( ["Tórax Acromio-Clavicular IZQ Apertura"]);
      localStorage.setItem('localMenuValue', JSON.stringify(
        ["Tórax Acromio-Clavicular IZQ Apertura"]));
    }

  };





  const handleItemValue7 = () => {
    setMenuPosition(null);


if ( menuValue) {
      setMenuValue( [...menuValue ,"Cráneo Occipital Flexión"]) 

      localStorage.setItem('localMenuValue', JSON.stringify(
        [...menuValue ,"Cráneo Occipital Flexión"]));
      
    } else {
      setMenuValue( ["Cráneo Occipital Flexión"]);
      localStorage.setItem('localMenuValue', JSON.stringify(
        ["Cráneo Occipital Flexión"]));
    }


    setMenuValue( [...menuValue ,"Tórax Acromio-Clavicular IZQ Cierre"] )
    localStorage.setItem('localMenuValue', JSON.stringify(
      [...menuValue ,"Tórax Acromio-Clavicular IZQ Cierre"]));



  };


  
  const handleItemValue8 = () => {
    setMenuPosition(null);

if ( menuValue) {
      setMenuValue( [...menuValue ,"Tórax Acromio-Clavicular DER Apertura"]) 

      localStorage.setItem('localMenuValue', JSON.stringify(
        [...menuValue ,"Tórax Acromio-Clavicular DER Apertura"]));
      
    } else {
      setMenuValue( ["Tórax Acromio-Clavicular DER Apertura"]);
      localStorage.setItem('localMenuValue', JSON.stringify(
        ["Tórax Acromio-Clavicular DER Apertura"]));
    }


  };

  const handleItemValue9 = () => {
    setMenuPosition(null);

if ( menuValue) {
      setMenuValue( [...menuValue ,"Tórax Acromio-Clavicular DER Cierre"]) 

      localStorage.setItem('localMenuValue', JSON.stringify(
        [...menuValue ,"Tórax Acromio-Clavicular DER Cierre"]));
      
    } else {
      setMenuValue( ["Tórax Acromio-Clavicular DER Cierre"]);
      localStorage.setItem('localMenuValue', JSON.stringify(
        ["Tórax Acromio-Clavicular DER Cierre"]));
    }

  };


  const handleItemValue10 = () => {
    setMenuPosition(null);

if ( menuValue) {
      setMenuValue( [...menuValue ,"Tórax Esternón Extensión"]) 

      localStorage.setItem('localMenuValue', JSON.stringify(
        [...menuValue ,"Tórax Esternón Extensión"]));
      
    } else {
      setMenuValue( ["Tórax Esternón Extensión"]);
      localStorage.setItem('localMenuValue', JSON.stringify(
        ["Tórax Esternón Extensión"]));
    }

  };


  const handleItemValue11 = () => {
    setMenuPosition(null);

if ( menuValue) {
      setMenuValue( [...menuValue ,"Tórax Esternón Flexión"]) 

      localStorage.setItem('localMenuValue', JSON.stringify(
        [...menuValue ,"Tórax Esternón Flexión"]));
      
    } else {
      setMenuValue( ["Tórax Esternón Flexión"]);
      localStorage.setItem('localMenuValue', JSON.stringify(
        ["Tórax Esternón Flexión"]));
    }

  };


  /* Pelvis */
  const handleItemValue12 = () => {
    setMenuPosition(null);

if ( menuValue) {
      setMenuValue( [...menuValue ,"Pelvis Ilíaco IZQ Apertura"]) 

      localStorage.setItem('localMenuValue', JSON.stringify(
        [...menuValue ,"Pelvis Ilíaco IZQ Apertura"]));
      
    } else {
      setMenuValue( ["Pelvis Ilíaco IZQ Apertura"]);
      localStorage.setItem('localMenuValue', JSON.stringify(
        ["Pelvis Ilíaco IZQ Apertura"]));
    }

  };


  const handleItemValue13 = () => {
    setMenuPosition(null);


if ( menuValue) {
      setMenuValue( [...menuValue ,"Pelvis Ilíaco IZQ Cierre"]) 

      localStorage.setItem('localMenuValue', JSON.stringify(
        [...menuValue ,"Pelvis Ilíaco IZQ Cierre"]));
      
    } else {
      setMenuValue( ["Pelvis Ilíaco IZQ Cierre"]);
      localStorage.setItem('localMenuValue', JSON.stringify(
        ["Pelvis Ilíaco IZQ Cierre"]));
    }

  };


  const handleItemValue14 = () => {
    setMenuPosition(null);

if ( menuValue) {
      setMenuValue( [...menuValue ,"Pelvis Ilíaco DER Apertura"]) 

      localStorage.setItem('localMenuValue', JSON.stringify(
        [...menuValue ,"Pelvis Ilíaco DER Apertura"]));
      
    } else {
      setMenuValue( ["Pelvis Ilíaco DER Apertura"]);
      localStorage.setItem('localMenuValue', JSON.stringify(
        ["Pelvis Ilíaco DER Apertura"]));
    }

  };


  const handleItemValue15 = () => {
    setMenuPosition(null);


if ( menuValue) {
      setMenuValue( [...menuValue ,"Pelvis Ilíaco DER Cierre"]) 

      localStorage.setItem('localMenuValue', JSON.stringify(
        [...menuValue ,"Pelvis Ilíaco DER Cierre"]));
      
    } else {
      setMenuValue( ["Pelvis Ilíaco DER Cierre"]);
      localStorage.setItem('localMenuValue', JSON.stringify(
        ["Pelvis Ilíaco DER Cierre"]));
    }

  };


  const handleItemValue16 = () => {
    setMenuPosition(null);

if ( menuValue) {
      setMenuValue( [...menuValue ,"Pelvis Sacro Extensión"]) 

      localStorage.setItem('localMenuValue', JSON.stringify(
        [...menuValue ,"Pelvis Sacro Extensión"]));
      
    } else {
      setMenuValue( ["Pelvis Sacro Extensión"]);
      localStorage.setItem('localMenuValue', JSON.stringify(
        ["Pelvis Sacro Extensión"]));
    }

  };


  const handleItemValue17 = () => {
    setMenuPosition(null);

if ( menuValue) {
      setMenuValue( [...menuValue ,"Pelvis Sacro Flexión"]) 

      localStorage.setItem('localMenuValue', JSON.stringify(
        [...menuValue ,"Pelvis Sacro Flexión"]));
      
    } else {
      setMenuValue( ["Pelvis Sacro Flexión"]);
      localStorage.setItem('localMenuValue', JSON.stringify(
        ["Pelvis Sacro Flexión"]));
    }

  };

  /* Pie */
  const handleItemValue18 = () => {
    setMenuPosition(null);

if ( menuValue) {
      setMenuValue( [...menuValue ,"Pie Escafo-Cuboides IZQ Apertura"]) 

      localStorage.setItem('localMenuValue', JSON.stringify(
        [...menuValue ,"Pie Escafo-Cuboides IZQ Apertura"]));
      
    } else {
      setMenuValue( ["Pie Escafo-Cuboides IZQ Apertura"]);
      localStorage.setItem('localMenuValue', JSON.stringify(
        ["Pie Escafo-Cuboides IZQ Apertura"]));
    }

  };

  const handleItemValue19 = () => {
    setMenuPosition(null);

if ( menuValue) {
      setMenuValue( [...menuValue ,"Pie Escafo-Cuboides IZQ Cierre"]) 

      localStorage.setItem('localMenuValue', JSON.stringify(
        [...menuValue ,"Pie Escafo-Cuboides IZQ Cierre"]));
      
    } else {
      setMenuValue( ["Pie Escafo-Cuboides IZQ Cierre"]);
      localStorage.setItem('localMenuValue', JSON.stringify(
        ["Pie Escafo-Cuboides IZQ Cierre"]));
    }

  };


  const handleItemValue20 = () => {
    setMenuPosition(null);

if ( menuValue) {
      setMenuValue( [...menuValue ,"Pie Escafo-Cuboides DER Apertura"]) 

      localStorage.setItem('localMenuValue', JSON.stringify(
        [...menuValue ,"Pie Escafo-Cuboides DER Apertura"]));
      
    } else {
      setMenuValue( ["Pie Escafo-Cuboides DER Apertura"]);
      localStorage.setItem('localMenuValue', JSON.stringify(
        ["Pie Escafo-Cuboides DER Apertura"]));
    }

  };


  const handleItemValue21 = () => {
    setMenuPosition(null);


if ( menuValue) {
      setMenuValue( [...menuValue ,"CPie Escafo-Cuboides DER Cierre"]) 

      localStorage.setItem('localMenuValue', JSON.stringify(
        [...menuValue ,"CPie Escafo-Cuboides DER Cierre"]));
      
    } else {
      setMenuValue( ["CPie Escafo-Cuboides DER Cierre"]);
      localStorage.setItem('localMenuValue', JSON.stringify(
        ["CPie Escafo-Cuboides DER Cierre"]));
    }

  };


  const handleItemValue22 = () => {
    setMenuPosition(null);

if ( menuValue) {
      setMenuValue( [...menuValue ,"Pie Calcáneo Extensión"]) 

      localStorage.setItem('localMenuValue', JSON.stringify(
        [...menuValue ,"Pie Calcáneo Extensión"]));
      
    } else {
      setMenuValue( ["Pie Calcáneo Extensión"]);
      localStorage.setItem('localMenuValue', JSON.stringify(
        ["Pie Calcáneo Extensión"]));
    }

  };


  const handleItemValue23 = () => {
    setMenuPosition(null);


if ( menuValue) {
      setMenuValue( [...menuValue ,"Pie Calcáneo Flexión"]) 

      localStorage.setItem('localMenuValue', JSON.stringify(
        [...menuValue ,"Pie Calcáneo Flexión"]));
      
    } else {
      setMenuValue( ["Pie Calcáneo Flexión"]);
      localStorage.setItem('localMenuValue', JSON.stringify(
        ["Pie Calcáneo Flexión"]));
    }

  };

  /* console.log("menuItemRef.current",menuItemRef.current)  */

  return (
    <>
      <div className="col">
        <div className="d-flex justify-content-center">
          {showIcons && (
            <Button
              aria-controls="simple-menu"
              aria-haspopup="true"
              variant="contained"
              color="primary"
              onClick={handleRightClick}
            >
              Elija diagnóstico
            </Button>
          )}
          {/* <Typography>Right click to open menu</Typography> */}
          <Menu
            id="simple-menu"
            open={!!menuPosition}
            onClose={() => setMenuPosition(null)}
            anchorReference="anchorPosition"
            anchorPosition={menuPosition}
            MenuListProps={{ onMouseLeave: handleItemClick }}
          >
            {/* Cráneo */}
            <NestedMenuItem
              label="Cráneo"
              parentMenuOpen={!!menuPosition}
              onClick={handleItemClick}
            >
              <NestedMenuItem
                label="Temporal IZQ"
                parentMenuOpen={!!menuPosition}
                onClick={handleItemClick}
              >
                <MenuItem onClick={handleItemValue0}>Apertura</MenuItem>

                <MenuItem onClick={handleItemValue1}>Cierre</MenuItem>
              </NestedMenuItem>
              <NestedMenuItem
                label="Temporal DER"
                parentMenuOpen={!!menuPosition}
                onClick={handleItemClick}
              >
                <MenuItem onClick={handleItemValue2}>Apertura</MenuItem>

                <MenuItem onClick={handleItemValue3}>Cierre</MenuItem>
              </NestedMenuItem>
              <NestedMenuItem
                label="Occipital"
                parentMenuOpen={!!menuPosition}
                onClick={handleItemClick}
              >
                <MenuItem onClick={handleItemValue4}>Extensión</MenuItem>

                <MenuItem onClick={handleItemValue5}>Flexión</MenuItem>
              </NestedMenuItem>
            </NestedMenuItem>
            {/* Tórax */}
            <NestedMenuItem
              label="Tórax"
              parentMenuOpen={!!menuPosition}
              onClick={handleItemClick}
            >
              <NestedMenuItem
                label="Acromio-Clavicular IZQ"
                parentMenuOpen={!!menuPosition}
                onClick={handleItemClick}
              >
                <MenuItem onClick={handleItemValue6}>Apertura</MenuItem>

                <MenuItem onClick={handleItemValue7}>Cierre</MenuItem>
              </NestedMenuItem>
              <NestedMenuItem
                label="Acromio-Clavicular DER"
                parentMenuOpen={!!menuPosition}
                onClick={handleItemClick}
              >
                <MenuItem onClick={handleItemValue8}>Apertura</MenuItem>

                <MenuItem onClick={handleItemValue9}>Cierre</MenuItem>
              </NestedMenuItem>
              <NestedMenuItem
                label="Esternón"
                parentMenuOpen={!!menuPosition}
                onClick={handleItemClick}
              >
                <MenuItem onClick={handleItemValue10}>Extensión</MenuItem>

                <MenuItem onClick={handleItemValue11}>Flexión</MenuItem>
              </NestedMenuItem>
            </NestedMenuItem>
            {/* Pelvis */}
            <NestedMenuItem
              label="Pelvis"
              parentMenuOpen={!!menuPosition}
              onClick={handleItemClick}
            >
              <NestedMenuItem
                label="Ilíaco IZQ"
                parentMenuOpen={!!menuPosition}
                onClick={handleItemClick}
              >
                <MenuItem onClick={handleItemValue12}>Apertura</MenuItem>

                <MenuItem onClick={handleItemValue13}>Cierre</MenuItem>
              </NestedMenuItem>
              <NestedMenuItem
                label="Ilíaco DER"
                parentMenuOpen={!!menuPosition}
                onClick={handleItemClick}
              >
                <MenuItem onClick={handleItemValue14}>Apertura</MenuItem>

                <MenuItem onClick={handleItemValue15}>Cierre</MenuItem>
              </NestedMenuItem>
              <NestedMenuItem
                label="Sacro"
                parentMenuOpen={!!menuPosition}
                onClick={handleItemClick}
              >
                <MenuItem onClick={handleItemValue16}>Extensión</MenuItem>

                <MenuItem onClick={handleItemValue17}>Flexión</MenuItem>
              </NestedMenuItem>
            </NestedMenuItem>
            {/* Pie */}
            <NestedMenuItem
              label="Pie"
              parentMenuOpen={!!menuPosition}
              onClick={handleItemClick}
            >
              <NestedMenuItem
                label="Escafo-Cuboides IZQ"
                parentMenuOpen={!!menuPosition}
                onClick={handleItemClick}
              >
                <MenuItem onClick={handleItemValue18}>Apertura</MenuItem>

                <MenuItem onClick={handleItemValue19}>Cierre</MenuItem>
              </NestedMenuItem>
              <NestedMenuItem
                label="Escafo-Cuboides DER"
                parentMenuOpen={!!menuPosition}
                onClick={handleItemClick}
              >
                <MenuItem onClick={handleItemValue20}>Apertura</MenuItem>

                <MenuItem onClick={handleItemValue21}>Cierre</MenuItem>
              </NestedMenuItem>
              <NestedMenuItem
                label="Calcáneo"
                parentMenuOpen={!!menuPosition}
                onClick={handleItemClick}
              >
                <MenuItem onClick={handleItemValue22}>Extensión</MenuItem>

                <MenuItem onClick={handleItemValue23}>Flexión</MenuItem>
              </NestedMenuItem>
            </NestedMenuItem>
          </Menu>
        </div>

        
        <div className="d-flex justify-content-center mt-5">

          <ul>{ menuValue && menuValue.map(
            (item) => <li className="mb-2">{item}</li> )
            }
          </ul>

        </div> 


      </div>

    </>
  );
};

export default NestedMenuMUI;
